import { ComponentItemWithData } from "../..";
import { ChartConfigHelper } from "../../helpers/chartConfigHelper";
import DashboardChart from "../DashboardChart";
import RenderErrorCard from "./RenderErrorCard";
const RenderDashboardCard = (
  component: ComponentItemWithData,
  index: number
) => {
  const config = ChartConfigHelper.getChartConfig(
    component.module,
    component.configKey
  );

  if (!config) return RenderErrorCard(component, index, "dashboard-card-item");

  return (
    <div key={component.id} data-index={index}>
      <DashboardChart
        title={config.title}
        description={config.description}
        chartType={config.chartType}
        data={component.data || []}
        config={config.config}
        loading={false}
        error={
          component.data ||
            component?.configKey == "leads_form_key_stats_chart" ||
            component?.configKey == "deals_form_key_stats_chart"
            ? undefined
            : "No data available"
        }
      />
    </div>
  );
};
export default RenderDashboardCard;
